import { render, staticRenderFns } from "./_NotifContentMention.vue?vue&type=template&id=a8b6d876&scoped=true&"
import script from "./_NotifContentMention.vue?vue&type=script&lang=js&"
export * from "./_NotifContentMention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b6d876",
  null
  
)

export default component.exports